import 'bootstrap/js/dist/tab';

document.querySelectorAll('input[type="radio"][name="customer_radio"]').forEach((customerEl) => {
  customerEl.addEventListener('change', () => {
    let newHref = customerEl.dataset.href;

    // If a tab was previously selected, retain that while toggling between
    // residential and non-residential (eg, so you stay on the "Infrastructure"
    // tab while toggling).
    const hash = window.location.hash;
    if (hash) {
      const previousTab = hash.split('/')[2];
      if (previousTab) {
        newHref += `/${previousTab}`;
      }
    }

    // Toggle the residential/non-residential wrappers.
    if (customerEl.value === 'residential') {
      document.getElementById('non-residential-topics').style.display = 'none';
      document.getElementById('residential-topics').style.display = 'block';
    } else if (customerEl.value === 'non_residential') {
      document.getElementById('residential-topics').style.display = 'none';
      document.getElementById('non-residential-topics').style.display = 'block';
    }

    // Update URL on radio change for deep linking.
    window.history.replaceState(null, '', newHref);

    // Trigger a click on the underlying tab if one exists, so the tab
    // selection is persistent across customer type toggling.
    document.querySelector(`a[data-bs-toggle="tab"][href="${newHref}"]`)?.click();
  });
});

// Trigger tab switch on-load for deep links.
const hash = window.location.hash;
if (hash) {
  // Toggle between the residential and non-residential.
  const customerHash = `#/${hash.split('/')[1]}`
  document.querySelector(`input[type="radio"][data-href="${customerHash}"]`)?.click();

  // Toggle the tabs inside the separate residential and non-residential
  // sections.
  document.querySelector(`a[data-bs-toggle="tab"][href="${hash}"]`)?.click();
}

// Update URL on tab change for deep linking.
document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tabEl) => {
  tabEl.addEventListener('shown.bs.tab', () => {
    window.history.replaceState(null, '', tabEl.getAttribute('href'));
  });
});
